<template>
  <div class="portal-wrapper" style="background-image: url('static/img/background/Background_2x.jpg')">

    <div class="top-bar">
      <a class="logout-btn" href="api/logout" @click="handleLogout" :title="$t( 'general.logout')">
          <span class="sidebar-normal"><i class="fa fa-sign-out-alt"></i></span>
      </a>
      <span class="top-bar-text">{{ $t( "myFleet.slogan") }}</span>
      <img class="top-bar-logo" src="static/img/Flota_RGB_pos.jpg"/>
    </div>
    <div class="wrapper portal-content">

      <side-bar type="sidebar" :sidebar-links="$sidebar.sidebarLinks" active-color="danger">
        <!-- <user-menu></user-menu> -->
      </side-bar>

      <div class="main-panel">
        <top-navbar>
            <user-menu></user-menu>
        </top-navbar>

        <dashboard-content>
        </dashboard-content>

        <!-- <content-footer></content-footer> -->
      </div>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      handleLogout() {
        this.$store.user.data = null;
      }
    }
  }

</script>

<style scoped>
    .wrapper.full-page-background {
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: 100% 100%;
    }
    .full-page-background:before {
        content: ' ';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0.6;
        background-repeat: no-repeat;
        background-position: 50% 0;
        background-size: cover;
    }
    .top-bar {
      height: 100px;
      border-bottom: 2px solid #d6752d;
      z-index: 9990;
      background-color: white;
      position: fixed;
      width: 100%;
    }
    .top-bar-logo {
      max-height: 98px;
      float: right;
    }
    .top-bar-text {
      float: right;
      font-weight: bold;
      font-size: 1.3em;
      font-style: italic;
      color: #d6752d;
      font-style: italic;
      margin-top: 2.3em;
      margin-right: 85px;
    }
    .logout-btn {
      float: right;
      margin: 5px;
      color: gray;
      font-size: 1.6em;
    }
</style>
